const initialState = {
  step1: null,
  step2: null,
};

const hotelFormikValues = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_HOTEL_FORMIK_VALUES_STEP1':
      return {
        ...state,
        step1: action.payload,
      };
    case 'UPDATE_HOTEL_FORMIK_VALUES_STEP2':
      return {
        ...state,
        step2: action.payload,
      };
    default:
      return state;
  }
};

export default hotelFormikValues;
